import type { SVGProps } from 'react'
const LineArrowCircleDown = (props: SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		width={24}
		height={24}
		fill="none"
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			d="M2 12C2 6.485 6.485 2 12 2s10 4.485 10 10-4.485 10-10 10S2 17.515 2 12m1.5 0c0 4.685 3.815 8.5 8.5 8.5s8.5-3.815 8.5-8.5-3.815-8.5-8.5-8.5S3.5 7.315 3.5 12m9.25-4.5v6.69l2.22-2.22 1.06 1.06-3.145 3.145a1.25 1.25 0 0 1-.885.365c-.32 0-.64-.12-.885-.365L7.97 13.03l1.06-1.06 2.22 2.22V7.5z"
			clipRule="evenodd"
		/>
	</svg>
)
export { LineArrowCircleDown }
